import { Component, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { CurrentUserProfileDialogComponent } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { RtPlatform } from '@core/user-interface-legacy';
import { useProtectedControlsCallback } from '@core/user-interface-routing-logic';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

export const getCurrentUserProfileConfig = () => {
  const platform = inject(RtPlatform);
  const i18n = inject(I18nService);
  const protectedControls = useProtectedControlsCallback();

  return {
    mobileOptions: platform.IS_MOBILE
      ? {
          mobileDialog: true,
          mobileViewTitle: i18n.translate('tlc.current_user.mobile_heading'),
        }
      : undefined,
    closeGuard: () => protectedControls(() => true),
  };
};

@Component({
  selector: 'x-current-user-profile-dialog',
  template: ``,
  imports: [],
})
export class TellentCurrentUserProfileDialogWrapComponent extends DialogWrapComponent<CurrentUserProfileDialogComponent> {
  public readonly component = CurrentUserProfileDialogComponent;
  public readonly config = getCurrentUserProfileConfig();
}

export type TellentCurrentUserProfileDialogWebComponent = TellentWebComponent<
  TellentCurrentUserProfileDialogWrapComponent,
  'afterClosed' | 'open'
>;
